import {
  ClipboardList,
  MessageSquare,
  Dumbbell,
  MonitorUp,
  PersonStanding,
  Route,
  Settings,
  ShieldCheck,
  TrendingUp,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { HelpSectionId } from './help-types';

/** Each Help section wears the icon of its page in the side menu, so it is recognised at a glance. */
export const HELP_SECTION_ICONS: Record<HelpSectionId, LucideIcon> = {
  flows: Route,
  clients: Users,
  'posture-analysis': PersonStanding,
  sop: ClipboardList,
  'remote-assessment': MonitorUp,
  drills: Dumbbell,
  'ask-harry': MessageSquare,
  'progression-model': TrendingUp,
  settings: Settings,
  admin: ShieldCheck,
};
